// extracted by mini-css-extract-plugin
module.exports = {"hub-search-no-results":"hub-search-no-results__NHo_X"};